export enum BankAccountState {
  NEW = 'NEW',
  VERIFIED = 'VERIFIED',
  REJECTED = 'REJECTED',
}
export enum BankAccountType {
  ABFPAY = 'ABFPAY',
  SEPA = 'SEPA',
  SWIFT = 'SWIFT',
}
